export default {
  'importIssueDetails.printMessage': 'File details with import number <%= importNumber %> printed',
  'importIssueDetails.exportMessage':
    'File details with import number <%= importNumber %> exported',
  'importIssueDetails.printGrid': 'Print <%= gridName %>',
  'importIssueDetails.exportGrid': 'Export <%= gridName %>'
};
